import { ReactTFC } from "../../../../../../../utils/fp/missing-ts-parts";
import { DualCheckoutVisualButton } from "../DualCheckoutVisualButton";
import React, { useState } from "react";
import { PaymentMethodT } from "../../../data/available-payment-methods";
import Core from "@adyen/adyen-web/dist/types/core";
import GooglePayT from "@adyen/adyen-web/dist/types/components/GooglePay";
import { GooglePay } from "./GooglePay";
import { PaymentNameWithIcon } from "../PaymentNameWithIcon";
import { CheckoutSelectionState } from "../../../state/type";
import { OpenedPaymentMethod } from "../CheckoutPaymentMethod";

export const GooglePayPaymentMethod: ReactTFC<{
  paymentOption: {
    tag: "googlepay";
    merchantId: string;
    gatewayMerchantId: string;
  };
  className: string;
  openedPaymentMethod: OpenedPaymentMethod;
  setOpenedPaymentMethod: React.Dispatch<OpenedPaymentMethod>;
  disabled: boolean;
  adyenInstance: Core;
  environment: "test" | "live";
}> = props => {
  const [state, setState] = useState<GooglePayT | null>(null);

  return (
    <DualCheckoutVisualButton
      disabled={props.disabled}
      isSelected={props.openedPaymentMethod?.tag === "googlepay"}
      onClick={() => {
        props.openedPaymentMethod?.tag !== "googlepay" ? props.setOpenedPaymentMethod(null) : void 0;

        if (state) {
          void state.submit();
        }
      }}
      isOpened={true}
      isLoading={!state}
      className={props.className}
      Extension={
        <GooglePay
          adyenInstance={props.adyenInstance}
          environment={props.environment}
          googlePayOptions={props.paymentOption}
          data={
            props.openedPaymentMethod?.tag === "googlepay" && props.openedPaymentMethod.screen.tag === "selected"
              ? props.openedPaymentMethod.screen.data
              : null
          }
          state={state}
          setState={setState}
        />
      }
    >
      <PaymentNameWithIcon name={"googlepay"} label={"Google Pay"} />
    </DualCheckoutVisualButton>
  );
};
